import Skeleton from "./Skeleton";
import "./PreconAuthoringSkeleton.scss";

const STEPS = 8;

export default function PreconAuthoringSkeleton() {
  return (
    <div className="preconSkel">

      <div className="preconSkel__stepsBar">
        {Array.from({ length: STEPS }).map((_, i) => (
          <div key={i} className="preconSkel__stepPill">
            <Skeleton width={110} height={32} borderRadius={20} />
            {i < STEPS - 1 && <Skeleton width={16} height={2} />}
          </div>
        ))}
      </div>

      <div className="preconSkel__body">

        <div className="preconSkel__header">
          <Skeleton width={240} height={22} />
          <Skeleton width={380} height={14} />
        </div>

        <div className="preconSkel__card">
          <Skeleton width={160} height={14} />
          <div className="preconSkel__grid3">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="preconSkel__fieldGroup">
                <Skeleton width={90} height={11} />
                <Skeleton width="100%" height={36} borderRadius={6} />
              </div>
            ))}
          </div>
          <div className="preconSkel__grid3">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="preconSkel__fieldGroup">
                <Skeleton width={80} height={11} />
                <Skeleton width="100%" height={36} borderRadius={6} />
              </div>
            ))}
          </div>
        </div>

        <div className="preconSkel__card">
          <Skeleton width={130} height={14} />
          <div className="preconSkel__lines">
            <Skeleton width="100%" height={11} />
            <Skeleton width="90%" height={11} />
            <Skeleton width="80%" height={11} />
            <Skeleton width="70%" height={11} />
          </div>
          <div className="preconSkel__grid2">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="preconSkel__fieldGroup">
                <Skeleton width={100} height={11} />
                <Skeleton width="100%" height={36} borderRadius={6} />
              </div>
            ))}
          </div>
        </div>

      </div>

      <div className="preconSkel__publishBar">
        <Skeleton width={120} height={13} />
        <div className="preconSkel__publishBtns">
          <Skeleton width={90} height={36} borderRadius={6} />
          <Skeleton width={140} height={36} borderRadius={6} />
        </div>
      </div>

    </div>
  );
}
